const Datastore = require('nedb')

let patients = new Datastore({ filename: "./patients.db", autoload: true });

//patients.remove({})

export default patients;


// WEBPACK FOOTER //
// ./src/services/patients/index.js